import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    overflow: 'auto',
    width: '100%',

    '& > :first-child > :first-child': {
      marginTop: '0 !important'
    }
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    textTransform: 'uppercase',

    '& > .icon': {
      display: 'flex',
      alignItems: 'center',
      marginRight: '9px'
    },

    '& .buttons': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '& > :not(:last-child)': {
        marginRight: ({ smallMedia }) => (smallMedia ? '0.5rem' : '1rem')
      }
    }
  }
}))

export default useStyles
